import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';

import Iconify from 'src/components/iconify';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
import CustomPopoverJs, { usePopover as usePopoverJs } from 'src/components/custom-popover';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CustomPopover = CustomPopoverJs as React.ComponentType<any>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const usePopover = usePopoverJs as any;

import { type SortOption } from 'src/models/recipe/list/sort-config';

// ----------------------------------------------------------------------

type Props = {
  sort: string;
  onSort: (value: string) => void;
  sortOptions: SortOption[];
};

export default function RecipeSort({ sort, onSort, sortOptions }: Props) {
  const popover = usePopover();

  const sortLabel = sortOptions.find((option) => option.value === sort)?.label;

  return (
    <>
      <Button
        disableRipple
        color="inherit"
        onClick={popover.onOpen}
        endIcon={
          <Iconify
            icon={popover.open ? 'eva:arrow-ios-upward-fill' : 'eva:arrow-ios-downward-fill'}
          />
        }
        sx={{ fontWeight: 'fontWeightSemiBold' }}
      >
        Sortuj wg:
        <Box
          component="span"
          sx={{ ml: 0.5, fontWeight: 'fontWeightBold', textTransform: 'capitalize' }}
        >
          {sortLabel}
        </Box>
      </Button>

      <CustomPopover open={popover.open} onClose={popover.onClose} hiddenArrow sx={{ width: 140 }}>
        {sortOptions.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === sort}
            onClick={() => {
              popover.onClose();
              onSort(option.value);
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </CustomPopover>
    </>
  );
}

